import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';
import { resolveAuthenticatedSignupRedirect } from '../utils/authRedirect';
import { resolveRedirectWithFeatureFlags } from '../utils/postAuthNavigation';

/**
 * Redirects already-authenticated users away from /login, /register, /signup.
 * Resolves signup intent and feature-flag gates before navigating.
 */
const AuthenticatedAuthRedirect = ({ search, user }) => {
  const [target, setTarget] = useState(null);

  useEffect(() => {
    let cancelled = false;
    setTarget(null);

    (async () => {
      const path = resolveAuthenticatedSignupRedirect(search, user);
      const { path: resolved } = await resolveRedirectWithFeatureFlags(path);
      if (!cancelled) {
        setTarget(resolved);
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [search, user]);

  if (!target) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '40vh' }}>
        <CircularProgress size={40} />
      </Box>
    );
  }

  return <Navigate to={target} replace />;
};

export default AuthenticatedAuthRedirect;
